import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pageTitle, tabRail, cardShell } from '../app/glass/styles';
import HelpDesk from './HelpDesk';
import ActionCenter from './ActionCenter';
import { TERMS_SECTIONS } from './TermsAndConditions';
import Contact from './Contact';
import FAQ from './FAQ';

const TABS = [
  ['help', 'navigation.helpDesk'],
  ['action', 'navigation.actionCenter'],
  ['terms', 'navigation.termsAndConditions'],
  ['contact', 'navigation.contactUs'],
  ['faqs', 'navigation.faqs'],
];

function SupportPage() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const tab = TABS.some(([k]) => k === tabParam) ? tabParam : 'help';
  const setTab = (key) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', key);
    setSearchParams(next, { replace: true });
  };

  return (
    <>
      <div className="cz-wrap" style={{ display: 'flex', alignItems: 'center', gap: 24, marginTop: 6 }}>
        <div style={pageTitle}>{t('navigation.support')}</div>
      </div>
      <div className="cz-scroll-x" style={tabRail}>
        {TABS.map(([key, label]) => (
          <button key={key} type="button" className={`cz-tab ${tab === key ? 'on' : ''}`} onClick={() => setTab(key)}>
            {t(label)}
          </button>
        ))}
      </div>
      {tab === 'help' && <HelpDesk />}
      {tab === 'action' && <ActionCenter />}
      {tab === 'terms' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {(TERMS_SECTIONS || []).map((s) => (
            <div key={s.title} style={cardShell}>
              <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>{s.title}</div>
              <div style={{ fontSize: 13.5, color: 'var(--tx2)', lineHeight: 1.7, whiteSpace: 'pre-wrap' }}>{s.content}</div>
            </div>
          ))}
        </div>
      )}
      {tab === 'contact' && <Contact />}
      {tab === 'faqs' && <FAQ />}
    </>
  );
}

export default SupportPage;
